/* unplugin-vue-components disabled */import script from "./header-bottom.vue?vue&type=script&setup=true&lang=js"
export * from "./header-bottom.vue?vue&type=script&setup=true&lang=js"

import "./header-bottom.vue?vue&type=style&index=0&id=a8cbb28c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8cbb28c"]])

export default __exports__